module.exports = __webpack_public_path__ + "static/media/64d1095f-5e73-47df-aebb-ac90f237cdb6.a8c377e2.png";